// extracted by mini-css-extract-plugin
export default {"assistantRoot":"AssistantView_assistantRoot__DsBzH","bottomContainer":"AssistantView_bottomContainer__tLsJy"};